
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M23.405 10.294l.052.051c.39.391.39 1.026-.005 1.42l-8.475 8.475a.998.998 0 01-1.42.005l-.051-.052a1 1 0 01-.127-.155l-4.089-4.09A1.001 1.001 0 019.3 14.53l.07-.07a1.007 1.007 0 011.418-.008l3.522 3.522 7.677-7.676a.998.998 0 011.42-.004z"}})])
          )
        }
      }
    